import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="mb-4">
              <img src="/youseful-logo.svg" alt="Youseful Logo" className="h-10" />
            </div>
            <p className="text-sm text-gray-400">
              Factory-to-Consumer platform bringing transparency, quality, and affordability together.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/products" className="hover:text-red-500 transition-colors">Products</Link></li>
              <li><Link to="/#how-it-works" className="hover:text-red-500 transition-colors">How It Works</Link></li>
              <li><Link to="/#transparency" className="hover:text-red-500 transition-colors">Transparency</Link></li>
              <li><Link to="/#designers" className="hover:text-red-500 transition-colors">For Designers</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Our Values</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center space-x-2">
                <div className="w-1 h-4 bg-red-600"></div>
                <span>Transparency</span>
              </li>
              <li className="flex items-center space-x-2">
                <div className="w-1 h-4 bg-red-600"></div>
                <span>Cost</span>
              </li>
              <li className="flex items-center space-x-2">
                <div className="w-1 h-4 bg-red-600"></div>
                <span>Quality</span>
              </li>
              <li className="flex items-center space-x-2">
                <div className="w-1 h-4 bg-red-600"></div>
                <span>Service</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-red-500" />
                <span>info@youseful.shop</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-red-500" />
                <span>+91 7021931505</span>
              </li>
              <li className="flex items-center space-x-2">
                <MapPin className="h-4 w-4 text-red-500" />
                <span>Mumbai, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center">
          <p>&copy; {new Date().getFullYear()} Youseful Shop Pvt. Ltd. All rights reserved. For You. By You.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
